import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SmallOrderGanttComponent } from './small-order-gantt.component';


const routes: Routes = [
  {
    path: '',
    component: SmallOrderGanttComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmallOrderGanttRoutingModule { }
